export const translations = {
    en: {
      title: "To-Do Listify",
      addTaskPlaceholder: "Add a task...",
      categoryPersonal: "Personal",
      categoryWork: "Work",
      categoryUrgent: "Urgent",
      priorityLow: "Low",
      priorityMedium: "Medium",
      priorityHigh: "High",
      addButton: "Add",
      sortByDate: "Sort by Date",
      sortByPriority: "Sort by Priority",
      sortByDueDate: "Sort by Due Date",
      allCategories: "All Categories",
      showCompleted: "Show Completed",
      lightMode: "☀️ Light Mode",
      darkMode: "🌙 Dark Mode",
      clearCompleted: "Clear Completed",
      progress: "Progress",
      noTasks: "No tasks yet",
      due: "Due",
      noDueDate: "No due date",
      saveButton: "Save",
      cancelButton: "Cancel",
      loading: "Loading tasks...",
      error: "Failed to load tasks from storage. Please try again.",
      saveError: "Failed to save tasks. Storage may be full or unavailable.",
      storageWarning:
        "Local storage is unavailable (e.g., incognito mode). Tasks won't persist after refresh.",
    },
    th: {
      title: "To-Do Listify",
      addTaskPlaceholder: "เพิ่มงาน...",
      categoryPersonal: "ส่วนตัว",
      categoryWork: "งาน",
      categoryUrgent: "ด่วน",
      priorityLow: "ต่ำ",
      priorityMedium: "ปานกลาง",
      priorityHigh: "สูง",
      addButton: "เพิ่ม",
      sortByDate: "เรียงตามวันที่",
      sortByPriority: "เรียงตามลำดับความสำคัญ",
      sortByDueDate: "เรียงตามวันที่ครบกำหนด",
      allCategories: "ทุกหมวดหมู่",
      showCompleted: "แสดงงานที่เสร็จแล้ว",
      lightMode: "☀️ โหมดสว่าง",
      darkMode: "🌙 โหมดมืด",
      clearCompleted: "ล้างงานที่เสร็จแล้ว",
      progress: "ความคืบหน้า",
      noTasks: "ยังไม่มีงาน",
      due: "ครบกำหนด",
      noDueDate: "ไม่มีวันที่ครบกำหนด",
      saveButton: "บันทึก",
      cancelButton: "ยกเลิก",
      loading: "กำลังโหลดงาน...",
      error: "ไม่สามารถโหลดงานจากที่เก็บข้อมูลได้ กรุณาลองใหม่",
      saveError: "ไม่สามารถบันทึกงานได้ ที่เก็บข้อมูลอาจเต็มหรือไม่สามารถใช้งานได้",
      storageWarning:
        "ที่เก็บข้อมูลในเครื่องไม่สามารถใช้งานได้ (เช่น โหมดไม่ระบุตัวตน) งานจะไม่ถูกเก็บหลังรีเฟรช",
    },
  };